<template>
  <div
    class="home__header"
    :class="{
      'home__header--panel': isAuthPanelOpen,
      'home__header--scrolled': y > 0,
    }"
  >
    <router-link
      to="/"
      class="header__logo"
      @click.native="$emit('goToSection', 'homeShowcase')"
    >
      <img src="@/assets/img/logo.svg" alt="3V Rö" />
    </router-link>
    <ul class="home__header__ul">
      <li>
        <div class="link" @click="$emit('goToSection', 'homeServices')">
          <img src="@/assets/img/header/serv.svg" alt="services img" />
          <p>УСЛУГИ И ЦЕНИ</p>
        </div>
      </li>
      <li>
        <div class="link" @click="$emit('goToSection', 'homeLocations')">
          <img src="@/assets/img/header/locations.svg" alt="locations img" />
          <p>ЛОКАЦИИ</p>
        </div>
      </li>
      <li>
        <div class="link" @click="$emit('goToSection', 'homeHelpful')">
          <img src="@/assets/img/header/more.svg" alt="more img" />
          <p>ПОЛЕЗНО</p>
        </div>
      </li>
      <li>
        <div class="link" @click="$emit('goToSection', 'homeFooter')">
          <img src="@/assets/img/header/contacts.svg" alt="contacts img" />
          <p>КОНТАКТИ</p>
        </div>
      </li>
    </ul>
    <Button
      @click="toggleResults()"
      class="round button--bigger button--width blue"
      :class="{ 'button--panel': isAuthPanelOpen }"
    >
      <transition name="slide-left" mode="out-in">
        <span v-if="!isAuthPanelOpen" key="panel-toggle-text">
          <span>ВХОД - ОНЛАЙН РЕЗУЛТАТИ</span>
        </span>
        <span class="icon" v-else key="panel-toggle-icon">d</span>
      </transition>
    </Button>
    <AuthPanel
      v-if="isAuthPanelOpen"
      :registerMode="registerMode"
      @close="toggleResults"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button from "@/components/Button.vue";
import AuthPanel from "@/views/panels/AuthPanel";
export default {
  props: ["openAuthPanel", "openAuthPanelAndRegister"],
  components: {
    Button,
    AuthPanel,
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  watch: {
    openAuthPanel(to) {
      if (to) {
        this.toggleResults();
      }
    },
    openAuthPanelAndRegister(to) {
      if (to) {
        this.registerMode = true;
        this.toggleResults();
      }
    },
  },
  data() {
    return {
      isAuthPanelOpen: false,
      registerMode: false,
      y: window.scrollY,
    };
  },
  methods: {
    toggleResults() {
      if (this.isAuthPanelOpen) {
        this.isAuthPanelOpen = false;
        this.registerMode = false;
        this.$emit("auth-panel-closed");
      } else {
        if (this.currentUser._id) {
          this.$router.push("/app");
        } else {
          this.isAuthPanelOpen = true;
        }
      }
    },
    handleScroll() {
      this.y = window.scrollY;
    },
  },
  mounted() {
    document.addEventListener("scroll", this.handleScroll);

    this.$nextTick(() => {
      if (this.$route.query.login === "true") {
        this.toggleResults();
      }
    });
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";
@import "@/scss/mixins.scss";
@import "@/scss/transitions.scss";
.home__header {
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 3px 54px #00000029;
  backdrop-filter: blur(12px);
  align-items: center;
  display: flex;
  height: 120px;
  // max-height: 120px;
  justify-content: space-between;
  left: 0;
  padding: 10px 20px;
  position: fixed;
  top: 0;
  width: 100%;
  @include transition(all $transition $cubic);
  z-index: 10;

  &.home__header--scrolled {
    height: 98px;
    // max-height: 98px;
    &::before {
      opacity: 1;
    }
    .header__logo {
      @include transform(scale(1.3) translateX(10%) translateY(10%));
    }
  }

  &.home__header--panel {
    padding-right: 50px;
  }
}
.header__logo {
  align-items: center;
  display: flex;
  height: 100%;
  position: relative;
  @include hover();
  img {
    display: block;
    height: 100%;
  }
}

.home__header__ul {
  display: flex;
  li {
    align-items: center;
    display: inline-flex;
  }
  .link {
    color: #2a5584;
    position: relative;
    padding-left: 2rem;
    padding-right: 1rem;
    @include hover();

    img {
      display: none;
    }
    p {
      font-size: 0.9rem;
      white-space: nowrap;
      font-weight: 700;
    }
  }
}

// @media screen and (max-width: $xl) {
//   .home__header:not(.home__header--scrolled) {
//     height: 160px;
//   }
// }

@media screen and (max-width: $l) {
  .home__header:not(.home__header--scrolled) {
    height: 140px;
  }
  .home__header__ul {
    .link {
      padding-left: 1.5rem;
      padding-right: 0;
      display: flex;
      flex-direction: column;
      gap: 5px;

      p {
        font-size: 0.9rem;
      }
    }
  }
}

@media screen and (max-width: $sm) {
  .home__header {
    bottom: 0;
    max-height: $sm-nav-height;
    height: $sm-nav-height;
    background: initial;
    backdrop-filter: initial;
    box-shadow: initial;

    &.home__header--scrolled {
      max-height: $sm-nav-height;
      height: $sm-nav-height;
    }

    padding: 10px;
    top: initial;
    width: 100%;
    &.home__header--panel {
      padding-right: 10px;
    }

    .home__header__ul {
      background: #eaeaea;
      border-radius: 100px;
      padding: 5px 20px;
      width: 100%;
      justify-content: space-around;

      li:first-of-type {
        p {
          font-size: 0;

          &::after {
            content: "УСЛУГИ";
            font-size: 0.9rem;
            font-weight: 700;
            white-space: nowrap;
          }
        }
      }

      .link {
        padding: initial;

        img {
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
  .header__logo {
    display: none;
  }

  .button {
    display: none;
  }
}

@media screen and (max-width: $xs) {
  .home__header__ul {
    justify-content: space-between;
  }
}
</style>